import { fade } from '@material-ui/core/styles';


export const niceBoxShadow = (color: string) =>
  `0 12px 20px -10px ${fade(color, 0.28)},
   0 4px 20px 0 rgba(0, 0, 0, 0.12),
   0 7px 8px -5px ${fade(color, 0.2)}`;
